<div class="Center">
	<h4>Roles</h4>
</div>

<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstRoles"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedRoles"
		dataKey="RoleId"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--Selected-->

				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="RoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="RoleDesc">Role<p-sortIcon field="RoleDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-role>
			<tr [pSelectableRow]="role">
				<td>
					<p-tableCheckbox [pSelectableRow]="role" [value]="role"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ role[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Center TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
